import React from "react";
import PropTypes from "prop-types";

const ListboxGroup = ({ label, children, showLabel = false }) => {
  return (
    <>
      {showLabel && <li className="et-listbox--item-group">{label}</li>}
      <ul>{children}</ul>
    </>
  );
};

ListboxGroup.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  showLabel: PropTypes.bool,
};

export default ListboxGroup;
